export default __webpack_public_path__ + "static/media/photosAdultLeft.a9d0cbcc.png";